const validateOrigin = (receivedOrigin) => {
  const expectedOrigin = process.env.KMB_CLIENT_ADMIN_URL;

  return expectedOrigin === receivedOrigin;
};

const listen = callback => window.addEventListener('message', (event) => {
  const { origin, data } = event;

  if (validateOrigin(origin)) {
    callback(data);
  }
});

export default {
  listen,
};



// WEBPACK FOOTER //
// ./src/helpers/events/postMessage.js